import { render, staticRenderFns } from "./instanceInfo.vue?vue&type=template&id=12f3b6dd&"
import script from "./instanceInfo.vue?vue&type=script&lang=js&"
export * from "./instanceInfo.vue?vue&type=script&lang=js&"
import style0 from "./instanceInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports